import React from 'react';

const Report = ({ reportInfo }) => {
    return <div>report</div>;
};

export default Report;
